import { render, staticRenderFns } from "./Pie.vue?vue&type=template&id=536f9946&scoped=true&"
import script from "./Pie.vue?vue&type=script&lang=ts&"
export * from "./Pie.vue?vue&type=script&lang=ts&"
import style0 from "./Pie.vue?vue&type=style&index=0&id=536f9946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536f9946",
  null
  
)

export default component.exports